//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            currentScheme:{}, //checkout组件 展示的方案 
            schemeShow:false,
            defalue:{}, // 当前险种选定的方案 
        }
    },
    props: {
        schemeList : { // 列表
            type: Array,
            default: ()=>{
                return []
            }
        },
        value :{ //dialog 的显示隐藏
            type: Boolean,
            default:false
        },
    },

    computed: {
        scheme_code() { // 主站传入的上次选中的方案code
            return this.$route.query.scheme_code || ''
        }
    },
    watch: {
        value (newVal, oldVal) {
            this.schemeShow = newVal; 
            if(newVal && this.defalue.schemeCode) {
                this.currentScheme = this.defalue
            }
        },
        schemeList:{
            handler(newVal, oldVal) {
                this.resetScheme()
            },
            deep: true
        },
        schemeShow (newVal,oldVal){
            this.$emit('input',newVal)
        },
        
    },
   created () {
        this.resetScheme()
        this.$emit('changeScheme',this.defalue)
   },
   methods: {
       btnClick(){
           this.defalue = this.currentScheme
            this.STATISTICS_CONFIG.insur_insurinfoinput_schemecard_submit_click({"ex":{scheme:this.defalue.schemeName }})
           this.$emit('changeScheme',this.defalue)
           this.schemeShow = false
       },
       resetScheme(){
            // 根据地址栏的方案code / 后台返回的默认方案 设置当前选中的方案 
            [this.defalue] =  [this.currentScheme]  = this.schemeList.filter(item => {
                return this.scheme_code ? item.schemeCode ==  this.scheme_code : item.isDefault
            });
       },
       schemeClick(item){
           this.STATISTICS_CONFIG.insur_insurinfoinput_schemecard_click({"ex":{scheme:item.schemeName }})
       }
   },
}
